import React, { useState } from 'react'
import { Button, Col, Form, Icon, Input, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../../utils/hooks'
import _, { isNull } from 'lodash'

const DocUpdate = ({ form, onOk, onCancel, formData }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        expired: formData.expired,
        status: formData.status
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          expired: values.expired,
          status: values.status
        }
        if (!_.isEmpty(formData)) {
          data.heroId = formData.heroId
          data.docId = formData.docId
        }
        onOk(data)
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Expired Date">
        {getFieldDecorator(`expired`)(<Input type="date" />)}
      </Form.Item>
      <Form.Item label="Status">
        {getFieldDecorator(`status`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
            <Radio value={'APPROVED'}>APPROVE</Radio>
            <Radio value={'REJECT'}>REJECT</Radio>
            <Radio value={'EXPIRED'}>EXPIRED</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedDocUpdate = Form.create({ name: 'DocUpdate' })(DocUpdate)
export default WrappedDocUpdate